
// @ts-nocheck
import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { setLanguage } from "../actions/languageActions";
import { fetchUser } from "../actions/accountActions";
import PrivateRoute from "./utils/PrivateRoute";
import Home from "./static/Home";
import Login from "./account/login/Login";
import RecoverPassword from "./account/recoverPassword/RecoverPassword";
//import CreateAccount from "./account/createAccount/CreateAccount";
import VerifyEditedAccount from "../components/account/manageAccount/VerifyEditedAccount";
import CodeVerification from "./account/createAccount/CodeVerification";
import Sidebar from "./sidebar/Sidebar";
import Map from "./map/Map";
import ManageAccount from "./account/manageAccount/ManageAccount";
import Stats from "./insights/Stats";
import EVs from "./evs/EVs";
import Chargers from "./chargers/Chargers";
import Sessions from "./sessions/Sessions";
import BasicSupport from "./support/BasicSupport";
import Compare from "./comparator/Compare";
//import ComingSoon from "./static/ComingSoon";
import NotFound from "./static/NotFound";

const mapStateToProps = (state: {
  account: {
    loggedIn: boolean;
    createdAccount: boolean;
    verifyAccount: boolean;
    verifyEditedAccount: boolean;
    guestUser: boolean;
    invalidLogin: boolean;
    changedEmail: boolean;
    accountData: {
      internationalPrefix: string;
      phone: string;
    };
  };
  app: {
    brand: {
      brandName: string;
      tokenMapBox: string;
      endpointToSupport: string;
      endpointToPrivacy: string;
      endpointToTermsAndConditions: string;
      icons: {
        principalIcon: string;
        favicon: string;
        logo: string;
        mapIcon: object;
        cards: object;
      };
      colors: {
        primaryColor: string;
        secondaryColor: string;
      };
    };
  };
  i18n: {
    locale: string;
  };
}) => ({
  lang: state.i18n.locale,
  loggedIn: state.account.loggedIn,
  createdAccount: state.account.createdAccount,
  verifyAccount: state.account.verifyAccount,
  verifyEditedAccount: state.account.verifyEditedAccount,
  guestUser: state.account.guestUser,
  invalidLogin: state.account.invalidLogin,
  changedEmail: state.account.changedEmail,
  internationalPrefix: state.account.accountData.internationalPrefix,
  phone: state.account.accountData.phone,
  brand: state.app.brand,
});

const mapDispatch = { setLanguage, fetchUser };
const connector = connect(mapStateToProps, mapDispatch);

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & {
  loggedIn: boolean;
  locale: string;
  pathname: string;
};

let Router: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.setLanguage(props.locale);
  }, [props.locale]);

  useEffect(() => {
    if (props.internationalPrefix && props.phone)
      if (!props.guestUser) props.fetchUser(props.internationalPrefix, props.phone);
  }, [props.pathname]);


  /* Auto redirects the page to the same url but without the /pt/ */
  if (props.pathname.includes("/pt/")) {
    const newPath = props.pathname.replace("/pt/", "/");
    if (newPath !== props.pathname) {
      return <Redirect to={newPath} replace />;
    }
  }

  /* Auto redirects the page to the same url but without the /en/ */
  if (props.pathname.includes("/en/")) {
    const newPath = props.pathname.replace("/en/", "/");
    if (newPath !== props.pathname) {
      return <Redirect to={newPath} replace />;
    }
  }

  return (
    <>
      {!props.loggedIn && props.createdAccount && !props.verifyAccount && (
        <Redirect to={`/verifyCode`} />
      )}
      

      {/* Redirects to the login route if the url has no path */}
      {((props.pathname === '') || (props.pathname === '/'))  && <Redirect to={`/login`} />}


      {props.loggedIn &&
        !props.createdAccount &&
        !props.verifyAccount &&
        !props.verifyEditedAccount &&
        (props.pathname === `/login` ||
          props.pathname === `/login/` ||
          props.pathname === `/login/admin`) && (
          <Redirect to={`/insights`} />
        )}

      <Switch>
        <Route
          path={`/login/admin`}
          component={() => (
            <>
              <Login locale={props.lang} admin />
              <Home locale={props.lang} />
            </>
          )}
        />
        <Route
          path={`/login`}
          component={() => (
            <>
              <Login locale={props.lang} />
              <Home locale={props.lang} />
            </>
          )}
        />
        <Route
          path={`/recoverPassword`}
          component={() => (
            <>
              <RecoverPassword />
              <Home locale={props.lang} />
            </>
          )}
        />
        {/* <Route
          path={`/createAccount`}
          component={() => (
            <>
              <CreateAccount locale={props.lang} />
              <Home locale={props.lang} />
            </>
          )}
        /> */}
        <Route
          path={`/verifyCode`}
          component={() => (
            <>
              <CodeVerification />
              <Home locale={props.lang} />
            </>
          )}
        />
        <Route
          path={`/verifyEditedAccountCode`}
          component={() => (
            <>
              <VerifyEditedAccount />
              <Home locale={props.lang} />
            </>
          )}
        />
        <PrivateRoute path={`/cockpit`}>
          <Redirect to={`/insights`} />
        </PrivateRoute>
        <PrivateRoute path={`/map`}>
          <>
            <Sidebar />
            <Map />
          </>
        </PrivateRoute>
        <PrivateRoute path={`/account`}>
          <>
            <Sidebar />
            <ManageAccount />
          </>
        </PrivateRoute>
        <PrivateRoute path={`/insights`}>
          <Sidebar />
          <Stats />
        </PrivateRoute>
        <PrivateRoute path={`/fleets/plafonds`}>
          <Redirect to={`/fleets`} />
        </PrivateRoute>
        <PrivateRoute path={`/fleets`}>
          <>
            <Sidebar />
            <EVs />
          </>
        </PrivateRoute>
        <PrivateRoute path={`/chargers`}>
          <>
            <Sidebar />
            <Chargers />
          </>
        </PrivateRoute>
        <PrivateRoute path={`/sessions`}>
          <>
            <Sidebar />
            <Sessions />
          </>
        </PrivateRoute>
        {/* <PrivateRoute path={`/bookings`}>
          <Sidebar />
          <ComingSoon />
        </PrivateRoute> */}
        {props.brand?.brandName === "EVIO" && (
          <PrivateRoute path={`/comparator`}>
            <Sidebar />
            <Compare />
          </PrivateRoute>
        )}
        {/*         <PrivateRoute path={`/router`}>
          <Sidebar />
          <ComingSoon />
        </PrivateRoute> */}

        <PrivateRoute path={`/wallet`}>
          <Redirect to={`/insights`} />
        </PrivateRoute>

        <PrivateRoute path={`/support`}>
          <Sidebar />
          <BasicSupport />
        </PrivateRoute>
        <Route component={NotFound} />
      </Switch>
    </>
  );
};

export default connector(Router);
